import {ValueObject} from '@s-ui/domain'

import {BooleanSharedValueObject} from '../../shared/ValueObjects/BooleanSharedValueObject.js'

export class UserTraitTrackingValueObject extends ValueObject {
  #segmentPrefix = 'cnet_user_segment_'
  #traitKey
  #traitValue

  constructor({traitKey, traitValue}) {
    super()
    this.#traitKey = traitKey
    this.#traitValue = traitValue
  }

  static createFromApi({traitKey, traitValue}) {
    return new UserTraitTrackingValueObject({
      traitKey,
      traitValue: BooleanSharedValueObject.create({value: traitValue})
    })
  }

  get traitKey() {
    return this.#traitKey
  }

  get traitValue() {
    return this.#traitValue.value
  }

  get hasSegmentPrefix() {
    return this.#traitKey.startsWith(this.#segmentPrefix)
  }

  get value() {
    return {
      traitKey: this.traitKey,
      traitValue: this.traitValue
    }
  }
}
